import services from "../services";
import * as types from "./mutation-type";

export const ActionSetEmployees = ({ commit }, payload) => {
    commit(types.SET_EMPLOYEES, payload);
};

export const setEmployee = ({ commit }, payload) => {
    commit(types.SET_EMPLOYEE, payload);
};

export const ActionGetEmployee = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getEmployee();
        if (!data?.error) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionGetEmployees = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getEmployees(payload);
        if (!data?.error) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionSetEmployee = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.setEmployee(payload);
        if (!data?.error) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionSetAffiliateCode = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.setAffiliateCode(payload);
        if (!data?.error) {
            resolve(data);
        }
        reject(data);
    });
};
